import * as React from 'react';
import * as Promise from 'bluebird';
import { Component } from 'react';
import {
  ColumnDefinition,
  convertToFilterWithPlus,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { CHECKBOX_FIELDS, DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { parse } from 'query-string';
import { Loader } from 'Src/components/Loader/Loader';
import { Grid } from 'Src/components/Grid/Grid';
import { History, Location } from 'history';
import { imageCell } from '../../../../helpers/cell';
import { SchoolImageWithTicket } from '../../../../models/schoolImages';
import { SchoolJob } from '../../../../models/schoolJob';
import { SchoolJobImage } from '../../../../models/schoolImages';
import { getSchoolUserSchoolJob, approveSchoolJob } from '../../../../services/schoolUser/schoolJobs';
import { AppSchoolsUser2 } from '../../AppSchools2';
import {
  createSchoolUserSchoolJobImageTicket,
  getSchoolUserAllSchoolJobImages,
  getSchoolUserSchoolJobImages,
  getSchoolUserSchoolJobImagesCount,
  updateSchoolUserSchoolJobImage,
  createSchoolUserImagePreview,
} from '../../../../services/schoolUser/schoolJobImages';
import { SimpleModal } from '../../../../components/SimpleModal/SimpleModal';
import { SchoolAppSchoolJobImageForm } from './SchoolAppSchoolJobImageForm/SchoolAppSchoolJobImageForm';
import { SCHOOL_JOB_IMAGES_TABS, SCHOOL_JOB_STATUS } from '../../../../consts/schoolJob';
import { TABS } from '../../../../consts/common';
import { SchoolAppSchoolJobImageSummary } from './SchoolAppSchoolJobImageSummary/SchoolAppSchoolJobImageSummary';
import { GenericSummary } from '../../../../components/GenericSummary/GenericSummary';
import { ResizablePanel } from '../../../../components/ResizablePanel/ResizablePanel';
import { getSelectOptionForSchoolImageStatus } from '../../../../helpers/select';
import { getIsApproved } from '../../../../helpers/accessor';
import { Button } from 'Src/components/Button/Button';
import { createPortal } from 'react-dom';

const BASE_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Image',
    field: 'image',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: imageCell,
  },
  {
    text: 'Title',
    field: 'staffDataTitle',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'title'],
  },
  {
    text: 'Name',
    field: 'staffDataName',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'name'],
  },
  {
    text: 'Surname',
    field: 'staffDataSurname',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'surname'],
  },
  {
    text: 'Job title',
    field: 'staffDataJobTitle',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'jobTitle'],
  },
  {
    text: 'Status',
    field: 'isApproved',
    isSort: false,
    type: FILTER_TYPE.SELECT,
    accessor: getIsApproved,
  },
];

interface State {
  items: SchoolImageWithTicket[];
  currentPage: number;
  //  selectedItems: SchoolImageWithTicket[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  //  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  job: SchoolJob;
  isJobImageFormModalOpen: boolean;
  //  currentTabIndex: number;
  isConfirmHideModalOpen: boolean;
  selectedImageToHide?: SchoolImageWithTicket;
  isConfirmPreferredModalOpen: boolean;
  selectedImageForPreferred?: SchoolImageWithTicket;
  existingPreferredImage?: SchoolImageWithTicket;
  isPreviewModalOpen: boolean;
  selectedImageForPreview?: SchoolImageWithTicket;
  previewId: string;
  editingImage?: SchoolImageWithTicket;
  isReadOnlyMode: boolean;

  isConfirmFinalApproveModalOpen: boolean;
  selectedImageToApprove?: SchoolImageWithTicket;

  isApproveJobReminderModalOpen: boolean;
  isJobReadyToApprove: boolean;

  isFullImageOpen: boolean;
  fullImageUrl?: string;
  isActualSize: boolean;
  isComposite?: boolean;
  fullMainUrl?: string;
  fullPreviewUrl?: string;
  mainNaturalWidth?: number;
  mainNaturalHeight?: number;
  previewNaturalHeight?: number;
}

interface LocationState {
  jobId?: string;
  search?: string;
}

interface Props {
  user: AppSchoolsUser2;
  history: History;
  location: Location & { state: LocationState };
}

export class SchoolAppSchoolJobImages2 extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      //      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      //      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      job: undefined,
      isJobImageFormModalOpen: false,
      //      currentTabIndex: 0,
      isConfirmHideModalOpen: false,
      selectedImageToHide: undefined,
      isConfirmPreferredModalOpen: false,
      selectedImageForPreferred: undefined,
      existingPreferredImage: undefined,
      isPreviewModalOpen: false,
      selectedImageForPreview: undefined,
      previewId: '',
      editingImage: undefined,
      isReadOnlyMode: false,

      isConfirmFinalApproveModalOpen: false,
      selectedImageToApprove: undefined,

      isApproveJobReminderModalOpen: false,
      isJobReadyToApprove: false,

      isFullImageOpen: false,
      fullImageUrl: undefined as string | undefined,
      isActualSize: false,
      isComposite: false,
      fullMainUrl: undefined,
      fullPreviewUrl: undefined,
      mainNaturalWidth: undefined,
      mainNaturalHeight: undefined,
      previewNaturalHeight: undefined,
    };
  }

  private fullImgScrollRef = React.createRef<HTMLDivElement>();
  private isDragging = false;
  private dragStartX = 0;
  private dragStartY = 0;
  private startScrollLeft = 0;
  private startScrollTop = 0;

  private isImageDecided = (image: SchoolImageWithTicket): boolean => {
    return Boolean(image.isApproved || image.isNotRequired);
  };

  private checkJobReadyToApprove = (showReminder: boolean = false): any => {
    const { job } = this.state;

    if (!job || job.status !== SCHOOL_JOB_STATUS.NEW || job.photoType.name !== 'Group') {
      this.setState({ isJobReadyToApprove: false });
      return Promise.resolve(false);
    }

    const jobId = this.getJobId();

    return getSchoolUserAllSchoolJobImages(this.props.user, jobId, {}).then(allImages => {
      const visibleImages = allImages.filter(image => !image.isHidden);
      const isReady = visibleImages.length > 0 && visibleImages.every(this.isImageDecided);

      this.setState({
        isJobReadyToApprove: isReady,
        isApproveJobReminderModalOpen: showReminder && isReady,
      });

      return isReady;
    });
  };

  private updateJobAfterImageDecision = (): any => {
    return this.setItems().then(() => this.checkJobReadyToApprove(true));
  };

  private approveJob = (): void => {
    const jobId = this.getJobId();

    this.setState({
      isLoading: true,
      isApproveJobReminderModalOpen: false,
    });

    approveSchoolJob(this.props.user, jobId)
      .then(() => getSchoolUserSchoolJob(this.props.user, jobId))
      .then(freshJob => {
        this.setState({
          job: freshJob,
          isJobReadyToApprove: false,
        });
      })
      .then(() => this.setItems())
      .finally(() => this.setState({ isLoading: false }));
  };

  closeApproveJobReminderModal = () => {
    this.setState({
      isApproveJobReminderModalOpen: false,
    });
  };

  onApproveJobFromReminderClick = () => {
    this.setState(
      {
        isApproveJobReminderModalOpen: false,
      },
      () => this.approveJob()
    );
  };

  private approveSingleImage = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });
    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isApproved: true, isNotRequired: false })
      .then(() => this.updateJobAfterImageDecision())
      .finally(() => this.setState({ isLoading: false }));
  };

  getJobId(): string {
    const { history, location } = this.props;
    const search = parse(history.location.search);
    const jobId = location.state?.jobId || (search.job as string);
    return jobId;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.setAdditionalItems().then(res => {
      if (this.state.job) {
        this.setItems().then(() => this.checkJobReadyToApprove(false));
      }
    });
  }

  setAdditionalItems() {
    const { user } = this.props;
    const jobId = this.getJobId();

    return getSchoolUserSchoolJob(user, jobId)
      .then(job => {
        if (!job) {
          throw new Error('Job not found');
        }

        this.setState({
          job: job,
          isLoading: false,
        });

        return true;
      })
      .catch(error => {
        console.error('Error fetching job:', error);
        this.setState({ isLoading: false });
      });
  }

  getColumns(): ColumnDefinition[] {
    const { job } = this.state;

    if (!job) {
      return [...BASE_COLUMNS];
    }

    const isGroupJob = job.photoType.name === 'Group';
    const canZoom = isGroupJob;

    let columns: ColumnDefinition[];

    if (isGroupJob) {
      columns = [
        { text: 'Image', field: 'image', isSort: false, type: FILTER_TYPE.NONE, cell: imageCell },
        { text: 'Group Name', field: 'groupName', isSort: false, type: FILTER_TYPE.TEXT, accessor: ['groupName'] },
        { text: 'Status', field: 'isApproved', isSort: false, type: FILTER_TYPE.SELECT, accessor: getIsApproved },
      ];
    } else {
      columns = [...BASE_COLUMNS];
    }

    columns.push({
      text: 'Actions',
      field: 'actions',
      isSort: false,
      cell: (item: SchoolImageWithTicket): JSX.Element => {
        const jobStatus = job?.status;
        const isApprovedBySchool = jobStatus === SCHOOL_JOB_STATUS.APPROVED_BY_SCHOOL;
        const canOpenForm = jobStatus === SCHOOL_JOB_STATUS.NEW || isApprovedBySchool;

        return (
          <td className="custom-action-cell">
            <div className="action-button-container">
              <button onClick={() => this.onPreviewImageClick(item)} className="modern-button modern-save-button mr-2">
                Preview
              </button>
              <button
                onClick={() => (isApprovedBySchool ? this.onViewImageClick(item) : this.onEditImageClick(item))}
                className="modern-button modern-edit-button mr-2"
                disabled={!canOpenForm}
              >
                {isApprovedBySchool ? 'View' : 'Edit'}
              </button>
              {!item.isApproved && !item.isNotRequired && (
                <>
                  <button
                    onClick={() => this.onApproveImageClick(item)}
                    className="modern-button modern-save-button mr-2"
                    disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                  >
                    Approve
                  </button>
                  {isGroupJob && (
                    <button
                      onClick={() => this.onImageNotRequiredClick(item)}
                      className="modern-button modern-neutral-button mr-2"
                      disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                    >
                      Image not required
                    </button>
                  )}
                </>
              )}
              {item.isApproved && (
                <button
                  onClick={() => this.onCancelApprovalClick(item)}
                  className="modern-button modern-cancel-button mr-2"
                  disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                >
                  Cancel approval
                </button>
              )}
              {item.isNotRequired && (
                <button
                  onClick={() => this.onCancelNotRequiredClick(item)}
                  className="modern-button modern-cancel-button mr-2"
                  disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                >
                  Cancel not required
                </button>
              )}
              {!isGroupJob && (
                <>
                  <button
                    type="button"
                    className="modern-button modern-cancel-button mr-2"
                    disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                    onClick={() => this.onHideImageClick(item)}
                  >
                    Hide
                  </button>
                  {item.isPreferred ? (
                    <button
                      onClick={() => this.onUnstarImageClick(item)}
                      className="custom-action-button-thumbnails star-button"
                      disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                      style={{ marginLeft: '8px' }}
                    >
                      <img src="/dist/images/icon/unstar.png" alt="Unstar" className="star-icon" />
                    </button>
                  ) : (
                    <button
                      onClick={() => this.onPreferredClick(item)}
                      className="custom-action-button-thumbnails star-button"
                      disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                      style={{ marginLeft: '8px' }}
                    >
                      <img src="/dist/images/icon/star.png" alt="Preferred" className="star-icon" />
                    </button>
                  )}
                </>
              )}
            </div>
          </td>
        );
      },
    });
    return columns;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems(): Promise<boolean> {
    const { history, user } = this.props;
    const { job } = this.state;
    if (!job) return Promise.resolve(false);

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';
    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const filters = getFilters(this.getColumns(), search);
    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isShowFilter;
    const where = getServerFieldSectionWhere(filters);

    const order = sortColumnsName && sortDirection ? `${sortColumnsName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter(page, where, order);
    const jobId = this.getJobId();

    const countP = getSchoolUserSchoolJobImagesCount(user, jobId, where);
    const itemsP = getSchoolUserSchoolJobImages(user, jobId, serverQueryFilter);

    return Promise.all([countP, itemsP]).then(([countObj, items]) =>
      Promise.all(
        items.map(item => {
          const useKey =
            job.photoType.name === 'Group' && item.isEdited && item.keyForEdit ? item.keyForEdit : item.key;
          const useMime =
            job.photoType.name === 'Group' && item.isEdited && item.mimeTypeForEdit
              ? item.mimeTypeForEdit
              : item.mimeType;
          return createSchoolUserSchoolJobImageTicket(user, { key: useKey, mimeType: useMime });
        })
      ).then(tickets => {
        const imagesExtended = items.map((item, i) => ({
          ...item,
          ticket: tickets[i],
        }));

        this.setState({
          currentPage: page,
          sortDirection: sortDirection as TABLE_SORT_DIRECTION,
          sortColumnsName,
          isShowFilter,
          isDataFiltered,
          filters,
          items: imagesExtended,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false,
        });

        return true;
      })
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  /*  onItemClick = (index: number) => {
    const item = this.state.items[index];
    this.onPreviewImageClick(item);
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const jobId = this.getJobId();

    getSchoolUserAllSchoolJobImages(user, jobId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };
*/
  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
        case CHECKBOX_FIELDS.CHECKBOX: {
          const checked = event.target.checked;
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              value: '',
              checked: checked,
            },
          };
          break;
        }
        case CHECKBOX_FIELDS.TEXT:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              value: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = BASE_COLUMNS.find(col => col.field === filterField);
      const filterType = filter?.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({});

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onClearFilterClick = (): void => {
    this.setState({});

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}`,
      state: history.location.state,
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search } = state as any;
    const jobId = this.getJobId();

    history.push({
      pathname: '/schoolJobs',
      search: search,
      state: { jobId: jobId },
    });
  };

  onViewImageClick = (item: SchoolImageWithTicket) => {
    if (item.photoType?.name === 'Group') {
      this.props.history.push({
        pathname: `/schoolJobs/${this.getJobId()}/images/group-view/${item.id}`,
        state: { image: item, readOnly: true },
      });
    } else {
      this.setState({
        editingImage: item,
        isJobImageFormModalOpen: true,
        isReadOnlyMode: true,
      });
    }
  };

  onEditImageClick = (item: SchoolJobImage) => {
    if (item.photoType?.name === 'Group') {
      this.props.history.push({
        pathname: `/schoolJobs/${this.getJobId()}/images/group-edit/${item.id}`,
        state: { image: item },
      });
    } else {
      const imageWithTicket: SchoolImageWithTicket = {
        ...item,
        ticket: (item as any).ticket || { ticket: '' },
      };
      this.setState({
        editingImage: imageWithTicket,
        isJobImageFormModalOpen: true,
        isReadOnlyMode: false,
      });
    }
  };

  onHideImageClick = (item: SchoolImageWithTicket) => {
    this.setState({
      isConfirmHideModalOpen: true,
      selectedImageToHide: item,
    });
  };

  onPreferredClick = (item: SchoolImageWithTicket) => {
    if (item.isPreferred) return;

    const existingPreferred = this.state.items.find(
      i =>
        i.staffData?.name === item.staffData?.name &&
        i.staffData?.surname === item.staffData?.surname &&
        i.isPreferred === true
    );

    if (existingPreferred) {
      this.setState({
        isConfirmPreferredModalOpen: true,
        selectedImageForPreferred: item,
        existingPreferredImage: existingPreferred,
      });
    } else {
      const { user } = this.props;
      const jobId = this.getJobId();
      updateSchoolUserSchoolJobImage(user, jobId, item.id, { isPreferred: true })
        .then(() => {
          this.setItems();
        })
        .catch(error => {
          console.error('Error setting preferred image:', error);
        });
    }
  };

  onUnstarImageClick = (item: SchoolImageWithTicket) => {
    const { user } = this.props;
    const jobId = this.getJobId();
    updateSchoolUserSchoolJobImage(user, jobId, item.id, { isPreferred: false })
      .then(() => {
        this.setItems();
      })
      .catch(error => {
        console.error('Error unsetting preferred image:', error);
      });
  };

  onCancelButtonClick = () => {
    this.setState({
      isJobImageFormModalOpen: false,
      editingImage: undefined,
      isReadOnlyMode: false,
    });
  };

  onSubmitForm = (data: any) => {
    const { editingImage } = this.state;
    const { user } = this.props;
    if (!editingImage) return;

    const jobId = this.getJobId();
    const id = editingImage.id;

    this.setState({ isLoading: true });

    updateSchoolUserSchoolJobImage(user, jobId, id, data)
      .then(updatedImage => {
        return createSchoolUserSchoolJobImageTicket(user, updatedImage).then(ticket => ({ ...updatedImage, ticket }));
      })
      .then(imageWithTicket => {
        this.setState(
          {
            isJobImageFormModalOpen: false,
            editingImage: undefined,
          },
          () => this.setItems()
        );
      })
      .catch(err => {
        console.error('Error updating image:', err);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  closeConfirmHideModal = () => {
    this.setState({
      isConfirmHideModalOpen: false,
      selectedImageToHide: undefined,
    });
  };

  confirmHideImage = () => {
    const { user } = this.props;
    const { selectedImageToHide } = this.state;
    if (!selectedImageToHide) return;

    const jobId = this.getJobId();
    const imageId = selectedImageToHide.id;

    updateSchoolUserSchoolJobImage(user, jobId, imageId, { isHidden: true })
      .then(() => {
        this.closeConfirmHideModal();
        this.setItems();
      })
      .catch(error => {
        console.error('Error hiding image:', error);
      });
  };

  closeConfirmPreferredModal = () => {
    this.setState({
      isConfirmPreferredModalOpen: false,
      selectedImageForPreferred: undefined,
      existingPreferredImage: undefined,
    });
  };

  confirmPreferredImage = () => {
    const { user } = this.props;
    const jobId = this.getJobId();
    const { selectedImageForPreferred, existingPreferredImage } = this.state;
    if (!selectedImageForPreferred) return;

    updateSchoolUserSchoolJobImage(user, jobId, selectedImageForPreferred.id, { isPreferred: true })
      .then(() => {
        if (existingPreferredImage) {
          return updateSchoolUserSchoolJobImage(user, jobId, existingPreferredImage.id, { isPreferred: false });
        }
      })
      .then(() => {
        this.closeConfirmPreferredModal();
        this.setItems();
      })
      .catch(error => {
        console.error('Error updating preferred image:', error);
      });
  };

  openFullImage = (arg: string | { mainUrl: string; previewUrl?: string }) => {
    const sel = this.state.selectedImageForPreview;
    const isGroup = sel?.photoType?.name === 'Group';
    if (!isGroup) return;

    if (typeof arg === 'string') {
      this.setState({
        isFullImageOpen: true,
        fullImageUrl: arg,
        isComposite: false,
        fullMainUrl: undefined,
        fullPreviewUrl: undefined,
        isActualSize: false,
      });
    } else {
      const hasPreview = !!arg.previewUrl;
      this.setState({
        isFullImageOpen: true,
        isComposite: hasPreview,
        fullMainUrl: arg.mainUrl,
        fullPreviewUrl: hasPreview ? arg.previewUrl : undefined,
        fullImageUrl: hasPreview ? undefined : arg.mainUrl,
        isActualSize: false,
      });
    }
  };

  closeFullImage = () => {
    this.setState({ isFullImageOpen: false, fullImageUrl: undefined });
  };

  openOriginalFullImage = (item: SchoolImageWithTicket) => {
    const { user } = this.props;

    const isGroup = item.photoType?.name === 'Group';
    const useKey = isGroup && item.keyForEdit ? item.keyForEdit : item.key;
    const useMime = isGroup && item.mimeTypeForEdit ? item.mimeTypeForEdit : item.mimeType;

    if (!useKey || !useMime) return;

    this.setState({ isLoading: true });
    createSchoolUserSchoolJobImageTicket(user, { key: useKey, mimeType: useMime })
      .then(ticket => {
        const url = `${(window as any).apiFile}/storage/images/${ticket.ticket}`;
        this.openFullImage(url);
      })
      .catch(err => console.error('Error getting ticket for zoom (forEdit preferred):', err))
      .finally(() => this.setState({ isLoading: false }));
  };

  onPanStart = (e: React.MouseEvent) => {
    if (!this.state.isActualSize) return;
    const el = this.fullImgScrollRef.current;
    if (!el) return;

    this.isDragging = true;
    el.style.cursor = 'grabbing';

    this.dragStartX = e.clientX;
    this.dragStartY = e.clientY;
    this.startScrollLeft = el.scrollLeft;
    this.startScrollTop = el.scrollTop;

    e.preventDefault();
  };

  onPanMove = (e: React.MouseEvent) => {
    if (!this.isDragging) return;
    const el = this.fullImgScrollRef.current;
    if (!el) return;

    const dx = e.clientX - this.dragStartX;
    const dy = e.clientY - this.dragStartY;

    el.scrollLeft = this.startScrollLeft - dx;
    el.scrollTop = this.startScrollTop - dy;
  };

  onPanEnd = () => {
    if (!this.isDragging) return;
    this.isDragging = false;
    const el = this.fullImgScrollRef.current;
    if (el) el.style.cursor = this.state.isActualSize ? 'grab' : 'zoom-in';
  };

  onMainImgLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    this.setState({ mainNaturalWidth: img.naturalWidth, mainNaturalHeight: img.naturalHeight });
  };

  onPreviewImgLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    this.setState({ previewNaturalHeight: img.naturalHeight });
  };

  renderFullImageOverlay(): React.ReactNode {
    const {
      isFullImageOpen,
      isActualSize,
      isComposite,
      fullImageUrl,
      fullMainUrl,
      fullPreviewUrl,
      mainNaturalWidth,
      mainNaturalHeight,
      previewNaturalHeight,
    } = this.state;

    if (!isFullImageOpen) return null;

    const VIEW_W = Math.floor((typeof window !== 'undefined' ? window.innerWidth : 1200) * 0.96);
    const VIEW_H = Math.floor((typeof window !== 'undefined' ? window.innerHeight : 800) * 0.96);

    const mainReady = !!fullMainUrl && typeof mainNaturalWidth === 'number' && typeof mainNaturalHeight === 'number';
    const previewReady = !!fullPreviewUrl && typeof previewNaturalHeight === 'number';

    const probes = isComposite ? (
      <>
        {!mainReady && fullMainUrl && (
          <img
            src={fullMainUrl}
            alt=""
            onLoad={this.onMainImgLoad}
            style={{ position: 'absolute', visibility: 'hidden', pointerEvents: 'none' }}
          />
        )}
        {fullPreviewUrl && !previewReady && (
          <img
            src={fullPreviewUrl}
            alt=""
            onLoad={this.onPreviewImgLoad}
            style={{ position: 'absolute', visibility: 'hidden', pointerEvents: 'none' }}
          />
        )}
      </>
    ) : null;

    const renderComposite = () => {
      const mainReady = typeof mainNaturalWidth === 'number' && typeof mainNaturalHeight === 'number';
      const captionReady = !fullPreviewUrl || typeof previewNaturalHeight === 'number';

      if (!mainReady || !captionReady) {
        return (
          <img
            src={fullMainUrl!}
            alt="Main"
            draggable={false}
            onLoad={this.onMainImgLoad}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block' }}
          />
        );
      }

      const mainW = Math.max(mainNaturalWidth || 1, 1);
      const mainH = Math.max(mainNaturalHeight || 1, 1);
      const capH = fullPreviewUrl ? Math.max(previewNaturalHeight || 1, 1) : 0;

      const fitMainByW = VIEW_W / mainW;
      const fitMainByH = VIEW_H / mainH;
      let mainScale = this.state.isActualSize ? 1 : Math.min(fitMainByW, fitMainByH);

      const mainDrawH = mainH * mainScale;
      const freeH = Math.max(VIEW_H - mainDrawH, 0);

      let captionScale = 0;
      if (capH > 0) {
        const capMax = mainScale;
        const capFitH = freeH / capH;
        captionScale = this.state.isActualSize ? 1 : Math.min(capMax, capFitH);
      }

      const targetW = this.state.isActualSize ? mainW : Math.round(mainW * mainScale);

      const wrapStyle: React.CSSProperties = { width: targetW };
      const imgMainStyle: React.CSSProperties = {
        width: '100%',
        height: 'auto',
        display: 'block',
        verticalAlign: 'top',
      };

      const capStyle: React.CSSProperties = fullPreviewUrl
        ? {
            transform: `scale(${captionScale || 0})`,
            transformOrigin: 'top center',
            width: '100%',
            height: 'auto',
            display: captionScale > 0 ? 'block' : 'none',
            willChange: 'transform',
          }
        : {};

      const onToggleSize = (e: React.MouseEvent) => {
        e.stopPropagation();
        this.setState(s => ({ isActualSize: !s.isActualSize }));
      };

      return (
        <div style={wrapStyle}>
          <img
            src={fullMainUrl!}
            alt="Main"
            draggable={false}
            onLoad={this.onMainImgLoad}
            onClick={onToggleSize}
            style={imgMainStyle}
            title={this.state.isActualSize ? 'Click to fit | Drag to pan' : 'Click for 100%'}
          />
          {fullPreviewUrl && (
            <img
              src={fullPreviewUrl}
              alt="Caption"
              draggable={false}
              onLoad={this.onPreviewImgLoad}
              onClick={onToggleSize}
              style={capStyle}
              title={this.state.isActualSize ? 'Click to fit | Drag to pan' : 'Click for 100%'}
            />
          )}
        </div>
      );
    };

    const renderSingle = () => (
      <img
        src={fullImageUrl!}
        alt="Full size"
        draggable={false}
        onLoad={this.onMainImgLoad}
        onClick={e => {
          e.stopPropagation();
          this.setState(s => ({ isActualSize: !s.isActualSize }));
        }}
        style={
          this.state.isActualSize
            ? {
                width: (this.state.mainNaturalWidth ?? undefined) as any,
                height: 'auto',
                display: 'block',
              }
            : {
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                display: 'block',
              }
        }
        title={this.state.isActualSize ? 'Click to fit | Drag to pan' : 'Click for 100%'}
      />
    );

    const overlay = (
      <div
        onClick={this.closeFullImage}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.85)',
          zIndex: 9999,
          display: 'grid',
          placeItems: 'center',
          cursor: 'zoom-out',
        }}
      >
        {probes}

        <div
          ref={this.fullImgScrollRef}
          onMouseDown={this.onPanStart}
          onMouseMove={this.onPanMove}
          onMouseUp={this.onPanEnd}
          onMouseLeave={this.onPanEnd}
          onClick={e => {
            if (e.target === e.currentTarget) this.closeFullImage();
            e.stopPropagation();
          }}
          style={{
            width: VIEW_W,
            height: VIEW_H,
            overflow: this.state.isActualSize ? 'auto' : 'hidden',
            display: 'grid',
            placeItems: 'center',
            borderRadius: 8,
            cursor: this.state.isActualSize ? 'grab' : 'zoom-in',
            background: 'transparent',
            boxSizing: 'border-box',
          }}
        >
          {isComposite ? renderComposite() : renderSingle()}
        </div>

        <button
          onClick={this.closeFullImage}
          aria-label="Close"
          style={{
            position: 'fixed',
            top: 16,
            right: 16,
            fontSize: 28,
            background: 'transparent',
            color: '#fff',
            border: 'none',
            pointerEvents: 'auto',
          }}
        >
          ×
        </button>

        <button
          onClick={e => {
            e.stopPropagation();
            this.setState(s => ({ isActualSize: !s.isActualSize }));
          }}
          style={{
            position: 'fixed',
            top: 16,
            right: 56,
            background: 'rgba(255,255,255,0.92)',
            border: 'none',
            borderRadius: 6,
            padding: '6px 10px',
            cursor: 'pointer',
            pointerEvents: 'auto',
          }}
        >
          {this.state.isActualSize ? 'Fit to screen' : '100%'}
        </button>
      </div>
    );

    return createPortal(overlay, document.body);
  }

  renderFormModal(): React.ReactNode {
    const { isJobImageFormModalOpen, editingImage, isReadOnlyMode } = this.state;
    if (!isJobImageFormModalOpen || !editingImage) return null;

    return (
      <SimpleModal
        isOpen={isJobImageFormModalOpen}
        customClass="custom-user-modal"
        onCloseClick={this.onCancelButtonClick}
      >
        <SchoolAppSchoolJobImageForm
          image={editingImage}
          onCancel={this.onCancelButtonClick}
          onSubmit={this.onSubmitForm}
          readOnly={isReadOnlyMode}
        />
      </SimpleModal>
    );
  }

  onPreviewImageClick = (item: SchoolImageWithTicket) => {
    const { user } = this.props;
    if (item.photoType?.name === 'Group' && item.isEdited) {
      const params = {
        imageId: item.id,
        job: item.job,
        fileName: item.fileName,
        mimeType: item.mimeType,
        key: item.key,
        groupName: item.groupName,
        school: item.school,
        photoType: item.photoType,
        fontName: item.fontName,
        groupStudents: item.groupStudents,
        crestLeft: item.crestLeft?.pic || '',
        crestRight: item.crestRight?.pic || '',
      };
      createSchoolUserImagePreview(user, params)
        .then(data =>
          this.setState({ selectedImageForPreview: item, previewId: data.previewId, isPreviewModalOpen: true })
        )
        .catch(err => console.error('Error generating preview', err));
    } else {
      this.setState({ selectedImageForPreview: item, previewId: '', isPreviewModalOpen: true });
    }
  };

  onApproveImageClick = (item: SchoolImageWithTicket) => {
    this.approveSingleImage(item);
  };

  onImageNotRequiredClick = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });

    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isApproved: false, isNotRequired: true })
      .then(() => this.updateJobAfterImageDecision())
      .finally(() => this.setState({ isLoading: false }));
  };

  onCancelApprovalClick = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });
    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isApproved: false })
      .then(() => this.setItems())
      .finally(() => this.setState({ isLoading: false }));
  };

  onCancelNotRequiredClick = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });
    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isNotRequired: false })
      .then(() => this.setItems())
      .finally(() => this.setState({ isLoading: false }));
  };

  closeConfirmFinalApproveModal = () => {
    this.setState({
      isConfirmFinalApproveModalOpen: false,
      selectedImageToApprove: undefined,
    });
  };

  confirmFinalApprove = () => {
    const { selectedImageToApprove } = this.state;
    const jobId = this.getJobId();
    if (!selectedImageToApprove) return;

    this.setState({ isLoading: true });

    updateSchoolUserSchoolJobImage(this.props.user, jobId, selectedImageToApprove.id, {
      isApproved: true,
      isNotRequired: false,
    })
      .then(() => approveSchoolJob(this.props.user, jobId))
      .then(() => getSchoolUserSchoolJob(this.props.user, jobId))
      .then(freshJob => {
        this.setState({ job: freshJob });
      })
      .then(() => this.setItems())
      .catch(err => console.error('Error during final approve', err))
      .finally(() => {
        this.setState({
          isLoading: false,
          isConfirmFinalApproveModalOpen: false,
          selectedImageToApprove: undefined,
        });
      });
  };

  closePreviewModal = () => {
    this.setState({
      isPreviewModalOpen: false,
      selectedImageForPreview: undefined,
      previewId: '',
    });
  };

  renderPreviewModal(): React.ReactNode {
    const { isPreviewModalOpen, selectedImageForPreview, previewId } = this.state;
    if (!isPreviewModalOpen || !selectedImageForPreview) return null;

    /*
    const mainUrl = `${window.apiFile}/storage/images/${selectedImageForPreview.ticket.ticket}`;
    const previewUrl = previewId ? `${window.apiBase}/schoolUser/imagePreview/${previewId}?t=${Date.now()}` : undefined;
    */
    const mainUrl = `${window.apiFile}/storage/images/${selectedImageForPreview.ticket.ticket}`;
    const previewUrl = previewId ? `${window.apiBase}/schoolUser/imagePreview/${previewId}?t=${Date.now()}` : undefined;

    const displayedUrl = previewUrl || mainUrl;

    const isGroupJob = selectedImageForPreview.photoType?.name === 'Group';
    const canZoom = isGroupJob;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        this.closePreviewModal();
      }
    };

    return (
      <div
        className="custom-modal-backdrop"
        onClick={handleBackdropClick}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="custom-modal-container"
          onClick={e => e.stopPropagation()}
          style={{
            position: 'relative',
            backgroundColor: '#fff',
            padding: 0,
            borderRadius: '8px',
            width: '80%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 3,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              padding: '10px 12px',
              background: 'linear-gradient(#ffffff, rgba(255,255,255,0.98))',
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              boxShadow: '0 1px 0 rgba(0,0,0,.06)',
            }}
          >
            {canZoom && (
              <button
                onClick={() => this.openOriginalFullImage(selectedImageForPreview)}
                title="Open full size"
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 52,
                  zIndex: 2,
                  fontSize: 20,
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                }}
                aria-label="Zoom"
              >
                🔍
              </button>
            )}

            <button
              onClick={this.closePreviewModal}
              style={{
                fontSize: 22,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                lineHeight: 1,
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>

          {/* КОНТЕНТ МОДАЛКИ */}
          <div style={{ padding: 20 }}>
            {isGroupJob && (
              <p
                style={{
                  fontStyle: 'italic',
                  margin: '0 0 10px',
                  color: '#FF4500',
                  textAlign: 'center',
                  fontSize: '1.25em',
                }}
              >
                This content is for preview only. The final printed result may differ.
              </p>
            )}

            <SchoolAppSchoolJobImageSummary
              mainUrl={mainUrl}
              previewUrl={previewUrl}
              isEdited={!!selectedImageForPreview.isEdited}
            />
          </div>
        </div>
      </div>
    );
  }

  renderConfirmFinalApproveModal(): React.ReactNode {
    if (!this.state.isConfirmFinalApproveModalOpen) return null;
    return (
      <SimpleModal isOpen={true} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Approve Last Image?</h2>
          <p>
            Once you approve this image, <strong>all</strong> images in this job will be approved and the entire job
            will automatically move to the “Approved by School” status. If you need to do any further checks, please
            cancel and review before proceeding.
          </p>
          <div className="d-flex justify-content-end" style={{ gap: '8px', marginTop: '20px' }}>
            <Button
              onClick={this.confirmFinalApprove}
              text="Yes, approve and finish job"
              customClass="modern-button modern-save-button"
            />
            <Button
              onClick={this.closeConfirmFinalApproveModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderApproveJobReminderModal(): React.ReactNode {
    if (!this.state.isApproveJobReminderModalOpen) {
      return null;
    }

    return (
      <SimpleModal isOpen={true} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>All images have been reviewed</h2>
          <p>
            All images in this job are now marked as either <strong>Approved</strong> or{' '}
            <strong>Image not required</strong>.
          </p>
          <p>
            Please remember to press <strong>Approve job</strong> to submit this job, or continue reviewing if you would
            like to make further changes.
          </p>

          <div className="d-flex justify-content-end" style={{ gap: '8px', marginTop: '20px' }}>
            <Button
              onClick={this.onApproveJobFromReminderClick}
              text="Approve job now"
              customClass="modern-button modern-save-button"
            />
            <Button
              onClick={this.closeApproveJobReminderModal}
              text="Continue reviewing"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderGrid(): React.ReactNode {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      //      selectedItems,
      filters,
      //      isSelectAllChecked,
      currentPage,
      total,
      job,
    } = this.state;

    if (!job) {
      return <Loader />;
    }

    const filterOptions = {
      isApproved: getSelectOptionForSchoolImageStatus(),
    };

    const gridTitle = `Job ${job.jobReference} / Images`;
    const isGroupJob = job.photoType.name === 'Group';
    const canApproveJob = isGroupJob && job.status === SCHOOL_JOB_STATUS.NEW && this.state.isJobReadyToApprove;

    return (
      <div className="school-job-images-page">
        <div className="school-job-images-header">
          <div>
            <h1>{gridTitle}</h1>
            {isGroupJob && (
              <p>
                Approve each group image, or mark it as image not required. Once every image has been reviewed, you will
                be able to approve the job.
              </p>
            )}
          </div>
          <button type="button" className="modern-button modern-view-button" onClick={this.goBack}>
            Back to jobs
          </button>
        </div>

        {canApproveJob && (
          <div className="school-job-approve-panel">
            <div>
              <strong>All images have been reviewed.</strong>
              <p>You can now approve this job, or make further changes before submitting it.</p>
            </div>
            <button type="button" className="modern-button modern-save-button" onClick={this.approveJob}>
              Approve job
            </button>
          </div>
        )}

        <Grid
          dataItems={items}
          filters={filters}
          currentPage={currentPage}
          total={total}
          isSelectAllChecked={false}
          isDataFiltered={isDataFiltered}
          sortDirection={sortDirection}
          sortColumnsName={sortColumnsName}
          isShowFilter={isShowFilter}
          dataItemsSelected={[]}
          columns={this.getColumns()}
          actionItems={[]}
          options={filterOptions}
          onItemClick={() => {}}
          onSortClick={this.onTableSortClick}
          onApplyFilterClick={this.onApplyFilterClick}
          onClearFilterClick={this.onClearFilterClick}
          onTableFilterChange={this.onTableFilterChange}
          onTableFilterClick={this.onTableFilterClick}
          setCurrentPageParams={this.setCurrentPageParams}
          onSelectAllClick={() => {}}
          onSelectAllOnPageClick={() => {}}
          onUnselectAllClick={() => {}}
          gridTitle={gridTitle}
          goBack={this.goBack}
          rowClassName="custom-table-row"
          disableCsvButton={true}
          filterButtonsVariant="schoolApp"
          disableSelection={true}
        />
      </div>
    );
  }

  /*  getTabs(): React.ReactNode {
    const { currentTabIndex, selectedItems, previewId } = this.state;

    const tabs = SCHOOL_JOB_IMAGES_TABS;
    const currentTab = tabs[currentTabIndex];
    const [image] = selectedItems;

    const previewUrl = previewId ? `${window.apiBase}/schoolUser/imagePreview/${previewId}?t=${Date.now()}` : undefined;

    switch (currentTab) {
      case TABS.SUMMARY:
        const mainUrl = `${window.apiFile}/storage/images/${image.ticket.ticket}`;
        const previewUrl = this.state.previewId
          ? `${window.apiBase}/schoolUser/imagePreview/${this.state.previewId}?t=${Date.now()}`
          : undefined;

        return <SchoolAppSchoolJobImageSummary mainUrl={mainUrl} previewUrl={previewUrl} isEdited={!!image.isEdited} />;
      default:
        return <div />;
    }
  }

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      currentTabIndex: index,
    });
  };

  renderSummary(): React.ReactNode {
    const { selectedItems, currentTabIndex } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select an image above</div>;
    }

    const tabs = this.getTabs();

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={SCHOOL_JOB_IMAGES_TABS} currentTabIndex={currentTabIndex}>
        {tabs}
      </GenericSummary>
    );
  }
*/
  renderConfirmHideModal(): React.ReactNode {
    if (!this.state.isConfirmHideModalOpen) return null;
    return (
      <SimpleModal isOpen={this.state.isConfirmHideModalOpen} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Confirm Hide</h2>
          <p>
            Are you sure you want to hide this image? Once hidden, it will be removed and won't be available anymore.
          </p>
          <div className="custom-button-container d-flex justify-content-end" style={{ gap: '8px' }}>
            <Button onClick={this.confirmHideImage} text="Confirm" customClass="modern-button modern-save-button" />
            <Button
              onClick={this.closeConfirmHideModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderConfirmPreferredModal(): React.ReactNode {
    if (!this.state.isConfirmPreferredModalOpen) return null;
    return (
      <SimpleModal isOpen={this.state.isConfirmPreferredModalOpen} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Replace Preferred Image?</h2>
          <p>
            There is already an image for this member of staff marked as preferred. Would you like to replace the
            preferred image?
          </p>
          <div className="custom-button-container d-flex justify-content-end" style={{ gap: '8px', marginTop: '20px' }}>
            <Button
              onClick={this.confirmPreferredImage}
              text="Confirm"
              customClass="modern-button modern-save-button"
            />
            <Button
              onClick={this.closeConfirmPreferredModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  render() {
    const { isLoading, isJobImageFormModalOpen, job } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    if (!job) {
      return <div>No job found. Please go back and select a job.</div>;
    }

    const classes = isJobImageFormModalOpen ? 'mt-3 modal-open' : 'mt-3';

    return (
      <div className={`${classes} schoolAppContentWrapper2`}>
        {' '}
        {this.renderFormModal()}
        {this.renderConfirmHideModal()}
        {this.renderConfirmPreferredModal()}
        {this.renderConfirmFinalApproveModal()}
        {this.renderApproveJobReminderModal()}
        {this.renderPreviewModal()}
        {this.renderFullImageOverlay()}
        <div className="row">
          <div className="col-md-12">
            <div className="resizable-panel">{this.renderGrid()}</div>
          </div>
        </div>
      </div>
    );
  }
}
